import DeviceCard from "components/DeviceCard";
import { db } from "config/firebaseConfig";
import { useAuth } from "context/AuthContext";
import { collection, getDocs } from "firebase/firestore";
import React, { useCallback, useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";

const Devices = () => {
  const { user } = useAuth();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const getDevices = useCallback(async () => {
    let devices = [];
    const colRef = collection(db, `users/${user.email}/devices`);
    (await getDocs(colRef)).docs.map((device) => {
      devices.push(device.data());
      setLoading(false);
      return true;
    });
    setDevices(devices);
  }, [user.email]);
  useEffect(() => {
    getDevices();
  }, [getDevices]);
  return (
    <div className=" w-full h-full flex flex-wrap  ">
      {devices.map((device, i) => {
        return <DeviceCard key={i} id={device.deviceName} user={user} />;
      })}
      {loading && (
        <div className=" flex  flex-1 w-full h-full justify-center items-center ">
          <Oval
            height={100}
            width={100}
            color="royalblue"
            secondaryColor="white"
          />
        </div>
      )}
    </div>
  );
};

export default Devices;
